import { CharacterLevel } from './constant'
import { difference, get } from 'lodash'

export const PagePermissions = {
  FACILITY: 'Facility',
  EXPERT: 'Expert',
  CLIENT: 'Client',
  METRICS_MANAGEMENT: 'MetricsManagement',
  CHALLENGES: 'Challenges',
  GOALS_ASPIRATIONS: 'Goals/aspirations',
  HSD: 'HSD',
  PROGRAM: 'Program',
  MESSAGING: 'Messaging',
  NOTES: 'Notes',
  SUPPORT_TEAM: 'SupportTeam',
  TRENDS: 'Trends',
  FILES: 'Files',
  WEEKLY_INSIGHTS: 'WeeklyInsights',
  HEALTH_COMPASS: 'HealthCompass',
  NUTRITION_SIGNALS_REPORT: 'NutritionSignalsReport',
  NUTRITION_SIGNALS_TRENDS: 'NutritionSignalsTrends',
  VITALS: 'Vitals',
  BODY_COMPOSITION: 'BodyComposition',
  BONE_DENSITY: 'BoneDensity',
  MOVEMENT_QUALITY_BALANCE: 'MovementQualityBalance',
  MUSCLE_FITNESS: 'MuscleFitness',
  AEROBIC_FITNESS: 'AerobicFitness',
  COGNITIVE_HEALTH: 'CognitiveHealth',
  BLOOD_PANEL: 'BloodPanel',
  RESOURCES: 'Resources',
  TIMELINE: 'Timeline'
}

export const AuthOp = {
  CREATE: 'create',
  DELETE: 'delete',
  UPDATE: 'update',
  VIEW: 'view'
}

export function ExcludeCharacters(excludes) {
  return difference(
    [
      CharacterLevel.expert,
      CharacterLevel.service_provider,
      CharacterLevel.admin,
      CharacterLevel.client,
      CharacterLevel.super_admin
    ],
    excludes
  )
}

export function PermFilter(perm, account) {
  const permissions = get(account, 'permissions')
  if (!permissions) {
    return false
  }
  if (!perm) {
    return true
  }
  const operations = get(permissions, [perm[0], 'operations']) || []
  return (
    operations.includes(perm.join('-')) ||
    account.user.person_character === CharacterLevel.super_admin
  )
}
